import styles from "./Progressbar.module.css"
//Progressbar
const Progressbar = ({percent, title}) =>
    <div>
        <div className={styles.Bar} style={{width: percent + "%"}}>{title} {percent} %</div>
    </div>

export default Progressbar